import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";

const MarketplaceRoute = () => {
  const isSeller = localStorage.getItem("is_marketplace_seller");
  const navigate = useNavigate();

  useEffect(() => {
    if (!isSeller) navigate(-1);
  }, []);

  return isSeller ? <Outlet /> : null;
};

export default MarketplaceRoute;
